import https from '@sg/utils/httpC';
import http from '@gp/utils/httpTS';
import axios from "axios";

// Business Management APIs
export const getExecutiveSummaryData = (payload: any): Promise<any> => https({
  url: '/api/v1/mgmt_pc/business/executive-summary',
  method: 'post',
  data: payload,
  rawData: true,
});

export const getExecutiveSummaryNotes = (params: { type: 'revenue' | 'profit' }): Promise<any> => https({
  url: '/api/v1/mgmt_pc/business/notes/fetch',
  method: 'post',
  data: params,
  rawData: true,
});

export const updateExecutiveSummaryNotes = (params: {
  type: 'revenue' | 'profit';
  note: string;
}): Promise<any> => https({
  url: '/api/v1/mgmt_pc/business/notes/save',
  method: 'post',
  data: params,
  rawData: true,
});

// Overall Financials APIs
export const getOverallGrossRevenueData = (payload: any): Promise<any> => https({
  url: '/api/v1/mgmt_pc/business/monthly-revenue',
  method: 'post',
  data: payload,
  rawData: true,
});

export const getOverallProfitData = (payload: any): Promise<any> => https({
  url: '/api/v1/mgmt_pc/business/monthly-profit',
  method: 'post',
  data: payload,
  rawData: true,
});

export const getOverallIncomeData = (payload: any): Promise<any> => https({
  url: '/api/v1/mgmt_pc/business/income-dashboard',
  method: 'post',
  data: payload,
  rawData: true,
});

export const getIEGGFinancialsDashboardData = (payload: any): Promise<any> => https({
  url: '/api/v1/mgmt_pc/business/iegg_financial_dashboard',
  method: 'post',
  data: payload,
  rawData: true,
});

// Project Highlight APIs
export const getProjectHighlights = (params: {} = {}): Promise<any> => https({
  url: '/api/v1/mgmt_pc/business/project-highlight/get',
  method: 'post',
  data: params,
  rawData: true,
});

export const createProjectHighlight = (params: any): Promise<any> => https({
  url: '/api/v1/mgmt_pc/business/project-highlight/create',
  method: 'post',
  data: params,
  rawData: true,
});

export const updateProjectHighlight = (params: {
  id: number;
  game_code: string;
  project_name: string;
  order?: number;
  content_orders: string;
}): Promise<any> => https({
  url: '/api/v1/mgmt_pc/business/project-highlight/update',
  method: 'post',
  data: params,
  rawData: true,
});

export const deleteProjectHighlight = (params: { id: number }): Promise<any> => https({
  url: '/api/v1/mgmt_pc/business/project-highlight/delete',
  method: 'post',
  data: params,
  rawData: true,
});

export const createProjectHighlightContent = (params: any): Promise<any> => https({
  url: '/api/v1/mgmt_pc/business/project-highlight/content/create',
  method: 'post',
  data: params,
  rawData: true,
});

export const updateProjectHighlightContent = (params: { id: number; type: string; value: string }): Promise<any> => https({
  url: '/api/v1/mgmt_pc/business/project-highlight/content/update',
  method: 'post',
  data: params,
  rawData: true,
});

export const deleteProjectHighlightContent = (params: { id: number }): Promise<any> => https({
  url: '/api/v1/mgmt_pc/business/project-highlight/content/delete',
  method: 'post',
  data: params,
  rawData: true,
});

export const updateProjectHighlightOrders = (params: {
  project_orders: Array<{ id: number; order: number }>
}): Promise<any> => https({
  url: '/api/v1/mgmt_pc/business/project-highlight/update-orders',
  method: 'post',
  data: params,
  rawData: true,
});

export const batchUpdateProjectHighlight = (params: {
  content_items_to_create: Array<{
    temp_id: string;
    type: string;
    value: string;
  }>;
  content_items_to_update: Array<{
    id: number;
    type: string;
    value: string;
  }>;
  content_items_to_delete: number[];
  projects_to_create: Array<{
    temp_id: string;
    game_code: string;
    project_name?: string;
    order: number;
    content_orders: string;
  }>;
  projects_to_update: Array<{
    id: number;
    order: number;
    content_orders: string;
  }>;
  projects_to_delete: number[];
}): Promise<any> => https({
  url: '/api/v1/mgmt_pc/business/project-highlight/batch-update',
  method: 'post',
  data: params,
  rawData: true,
});


export const downloadIEGGFinancialDashboard = (payload: any, apiUrl?: string) => {
  return new Promise((resolve, reject) => {
    const authorization = window.sessionStorage.getItem('authorization') || '';
    if (apiUrl) {
      axios({
        url: apiUrl,
        method: 'post',
        data: payload,
        errorHandler: true,
        responseType: 'blob',
        headers: {
          Accept: 'application/json, text/plain, */*',
          Authorization: authorization,
        },
      }).then(function (response) {
        if (response.status === 200 && response.data) {
          resolve(response);
        }
      }).catch(function (error) {
        reject(error);
      });
    }
  });
};
